import React from "react";

import "./user.scss"
import { Link, useNavigate } from "react-router-dom";

export default function UserPanel({ children }) {
  const [activeMenu, setActiveMenu] = React.useState("dashboard");
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  if (!user) {
    navigate("/login?returnTo=/dashboard");
    return;
  }

  return (
    <div className="app">
      <aside className="sidebar">
        <div className="brand">
          <div className="avatar">A</div>
          <div>
            <h2>World Adventure Tours</h2>
            <span>User Console</span>
          </div>
        </div>

        <nav className="menu">
          <Link to={"/dashboard"} className={activeMenu === "dashboard" ? "active" : ""} onClick={() => setActiveMenu("dashboard")}>
            Dashboard
          </Link>
          <Link to={"/my-bookings"} className={activeMenu === "bookings" ? "active" : ""} onClick={() => setActiveMenu("bookings")}>
            My Bookings
          </Link>
          <Link to={"/my-profile"} className={activeMenu === "profile" ? "active" : ""} onClick={() => setActiveMenu("profile")}>
            Profile
          </Link>
        </nav>

        <div className="sidebar-footer">
          <button onClick={(e)=> {
            e.preventDefault();
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            navigate("/")
          }}>Logout</button>
        </div>
      </aside>

      <main className="content">
        <header className="topbar">
          <h1>Overview</h1>
          <div className="actions">
            <img
              className="profile"
              src="https://i.pravatar.cc/40"
              alt="profile"
            />
          </div>
        </header>

        <section className="panel">
            {children}
        </section>
      </main>
    </div>
  );
}
